import React, { useCallback, useContext } from "react";
import "./CategorySelection.scss";
import { FaArrowRight } from "react-icons/fa";
import category1 from "../Images/category1.png";
import category2 from "../Images/category2.png";
import category3 from "../Images/category3.png";
import arrow from "../Images/Arrow 1.png";
import ReturnHome from "../Components/ReturnHome";
import { useNavigate } from "react-router";
import { DataContext } from "../App";
import viewNavigate from '../Utils/viewNavigate'
import useIdle from "../Hooks/useIdle";
const categories = [
  {
    title: "Easy Imaging",
    description:
      "Do you know how to optimize and simplify ultrasound image capture?",
    icon: category1,
  },
  {
    title: "Workflow Productivity",
    description:
      "How do automated ultrasound workflows make clinicians' tasks more efficient?",
    icon: category2,
  },
  {
    title: "Diagnostic Confidence",
    description:
      "How do AI-driven ultrasound solutions boost diagnostic precision and patient experience?",
    icon: category3,
  },
];

const CategorySelection = (props) => {
  const isIdle = useIdle();
  let navigate = useNavigate();
  const table = useContext(DataContext);
  const setCategory = useCallback((cat) => {
    /** @type {Array} */
    const tableArray = table;
    const filteredList = tableArray.filter((elem) => elem.Category === cat);
    const finalList = [];
    for (let i = 0; i < 3; i++) {
      const selectedId = Math.floor(Math.random() * filteredList.length);
      finalList[i] = filteredList.splice(selectedId, 1)[0];
    }
    console.log(cat, finalList, filteredList, table);
    props.setResponses(finalList);
    viewNavigate(navigate, "/CounterView");

  }, []);
  return (
    <div className="category-container">
      <h1 className="category-title">
        <p>Choose Your Category:</p>
      </h1>
      <ul className="category-list">
        {categories.map((cat, index) => (
          <li
            onClick={() => setCategory(cat.title)}
            key={index}
            className="category-item"
          >
            <img src={cat.icon} alt="category" className="category-icon" />
            <div className="category-text">
              <h2 className="category-name">{cat.title}</h2>
              <p className="category-description">{cat.description}</p>
            </div>
            <div className="circle">
              <img src={arrow} className="circle-arrow" alt="arrow" />
            </div>
          </li>
        ))}
      </ul>
      <div className="return-home-holder">
        <ReturnHome
          onClick={() => {
            viewNavigate(navigate, "/");
          }}
        />
      </div>
    </div>
  );
};

export default CategorySelection;
